<template>
  <div data-cy="send-files" class="flex gap-2 items-center justify-start">
    <icon-base
      v-tooltip="t('DEALS.PLACEMENT.SEND_ADDITIONAL_DOCUMENTS')"
      data-cy="add-files"
      :icon="IconAddDocument"
      class="text-label cursor-pointer"
      @click.stop="openFilesModal"
    />
  </div>
  <funder-files-modal
    v-if="showFilesModal && model.placement_id"
    :files-sent="value"
    :placement-id="model.placement_id"
    :close="() => (showFilesModal = false)"
  />
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import { AnalyticsEvent } from "@/enums/analytics";
import { useAnalyticsStore } from "@/stores/analytics";

import FunderFilesModal from "@/components/deals/placement/FunderFilesModal.vue";
import IconAddDocument from "@/components/icons/IconAddDocument.vue";
import IconBase from "@/components/ui/IconBase.vue";

import type { FileSent } from "@/models/common";
import type { IOffer } from "@/models/funders";

const { value, model } = defineProps<{
  value?: FileSent[];
  model: IOffer;
}>();

const { t } = useI18n();
const { trackEvent } = useAnalyticsStore();

const showFilesModal = ref(false);

const openFilesModal = () => {
  showFilesModal.value = true;
  trackEvent(AnalyticsEvent.PlacementAdditionalDocsOpened, {
    placement_id: model.placement_id,
  });
};
</script>
